import { handleHttp } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {};
  },
  watch: {},
  methods: {}
};